import React from 'react';

import {
  Datagrid,
  TextField,
  ReferenceField,
  ChipField,
  DateField,
  usePermissions,
} from 'react-admin';

import ReferenceEntityField from '../../../../customFields/ReferenceEntityField';
import StatusField from '../../../../customFields/StatusField';
import NoResults from '../../../layout/NoResults';
import LinkField from '../../../layout/LinkField';
import { boldDataGridStyle } from '../../../../constants/style/datagridStyles';
import EntityDisplayNameField from '../../../../customFields/EntityDisplayNameField';
import actions, { Actions } from '../../../../constants/actions';
import hasAccess from '../../../../utilities/hasAccess';

const Request = (
  {
    children,
  }: {
    children?: React.ReactNode;
  },
) => {
  const { permissions } = usePermissions<Actions[]>();

  return (
    <Datagrid sx={{ ...boldDataGridStyle }} bulkActionButtons={false} empty={<NoResults variant="h6" />}>
      {hasAccess(permissions, actions.REQUEST_GET) ? (
        <LinkField sortable={false} source="id" label="ID" />
      ) : (
        <TextField sortable={false} source="id" label="ID" />
      )}
      <TextField sortable={false} source="customId" label="Custom ID" />
      <DateField sortable source="createdAt" showTime />
      <StatusField sortable source="recommendation" />
      {hasAccess(permissions, actions.PROCESS_GET) && (
        <ReferenceField sortable reference="processes" source="process">
          <ChipField source="name" />
        </ReferenceField>
      )}
      <DateField sortable={false} source="extraInformation.date" showTime label="Transaction date" />
      <TextField sortable={false} source="extraInformation.amount" label="Amount" />
      <TextField sortable={false} source="extraInformation.currency" label="Currency" />
      <ReferenceEntityField sortable={false} source="extraInformation.processor" label="Processor">
        <EntityDisplayNameField />
      </ReferenceEntityField>
      <ReferenceEntityField sortable={false} source="extraInformation.subProcessor" label="Sub-processor">
        <EntityDisplayNameField />
      </ReferenceEntityField>
      <ReferenceEntityField sortable={false} source="extraInformation.recipient" label="Recipient">
        <EntityDisplayNameField />
      </ReferenceEntityField>
      <ReferenceEntityField sortable={false} source="extraInformation.initiator" label="Initiator">
        <EntityDisplayNameField />
      </ReferenceEntityField>
      {children}
    </Datagrid>
  );
};

export default Request;
